import { render, staticRenderFns } from "./ContentDeliveryRate.vue?vue&type=template&id=b2426e5c"
import script from "./ContentDeliveryRate.vue?vue&type=script&lang=js"
export * from "./ContentDeliveryRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports